import { Collection, CollectionLabel } from "../../../models"
import { ErrorFetchingAction, FetchErrorInfo, FetchRequestActions, StartFetchingAction, SuccessFetchingAction } from "../../../utils/request-actions-helpers/createRequestActions"
import { ChannelAction, SET_CHANNEL_UPDATE } from "./actions"
import {editLabelActionTypes, createLabelActionTypes, LabelAdditionalData, deleteLabelActionTypes, DeleteLabelAdditionalData, DeleteLabelResponse} from '../labels'

export interface ChannelState {
    channel: Collection | null
    // groupId?: string
    // isFetching?: boolean
    // fetchError?: FetchErrorInfo
}


export const initialChannelState: ChannelState = {
    channel: null
    // groupId?: string
    // isFetching?: boolean
    // fetchError?: FetchErrorInfo
}


export const channelReducer = (state: ChannelState = initialChannelState, action: ChannelAction): ChannelState => {
    switch (action.type) {
        // case getGroupForDocumentActionTypes.start: {
        //     const startFetchingAction = action
        //     const newState: ChannelState = {
        //         ...state,
        //         isFetching: true,
        //     }

        //     return newState
        // }
      
        case SET_CHANNEL_UPDATE: {
            // const successAction = action.result  as ChannelAction
            
            // console.log('successAction.result',successAction.result)
            // const newState: ChannelState = {
              return {
                ...state,
                // groupId: successAction.result.collectionGroup.groupUid,
                channel:   action.payload,
                // isFetching: false
              } 
            }
        //     return newState
        // }
        // case createLabelActionTypes.success: {
        //     const successAction = action as SuccessFetchingAction<CollectionLabel, LabelAdditionalData>
            
        //     if(!successAction.additionalData || !state.channel) return state
        //     const {collectionId} = successAction.additionalData
        //     if(collectionId !== state.channel.id) return state

        //     const newState: ChannelState = {
        //         ...state,
        //         channel: {
        //             ...state.channel,
        //             collectionLabels: [...state.channel.collectionLabels, successAction.result]
        //         },
        //     }
        //     return newState
        // }
        // case editLabelActionTypes.success: {
        //     const successAction = action as SuccessFetchingAction<CollectionLabel, LabelAdditionalData>
            
        //     if(!successAction.additionalData || !state.channel) return state
        //     const {collectionId} = successAction.additionalData
        //     if(collectionId !== state.channel.id) return state
            
        //     const newState: ChannelState = {
        //         ...state,
        //         channel: {
        //             ...state.channel,
        //             collectionLabels: state.channel.collectionLabels.map((label) => {
        //                 if(label.id !== successAction.result.id) return label
        //                 return successAction.result
        //             })
        //         },
        //     }
        //     return newState
        // }
        // case deleteLabelActionTypes.success: {
        //     const successAction = action as SuccessFetchingAction<DeleteLabelResponse, DeleteLabelAdditionalData>

        //     if(!successAction.additionalData || !state.channel) return state

        //     const {labelId} = successAction.additionalData
            
        //     const newState: ChannelState = {
        //         ...state,
        //         channel: {
        //             ...state.channel,
        //             collectionLabels: state.channel.collectionLabels.filter((label) => label.id !== labelId)
        //         },
        //     }
        //     return newState

        // }
        // case getGroupForDocumentActionTypes.error: {

        //     const newState: ChannelState = {
        //         isFetching: false,
        //         fetchError: (action as ErrorFetchingAction<any>).error,
        //     }
        //     return newState
        // }

        default:
            return state
    }
}

// import { RESULT_FILTERS_UPDATE, RESULT_CHANNEL_UPDATE, RESULT_CHANNEL_FILTER_UPDATE, RESULT_CHANNEL_EMPTY, FULL_RESET_STORE } from "../actionTypes/actionTypes";

// const initialState = [];

// const input = (state = initialState, action) => {
//     switch (action.type) {
//         case FULL_RESET_STORE:
//             return initialState;
//         case RESULT_FILTERS_UPDATE:
//             return {
//                 ...state,
//                 dataTypes: action.results.dataTypes ? [...action.results.dataTypes] :[],
//                 relatedDocs: action.results.relatedDocs   ? [...action.results.relatedDocs] : [],
//             }
//         case RESULT_CHANNEL_EMPTY:
//             return {
//                 ...state,
//                 relatedTagsQuery: [],
//                 channel: {},
//                 dataTypes: [],
//                 relatedDocs: [],
//             }
//         case RESULT_CHANNEL_UPDATE:

//             return {
//                 ...state,
//                 channel: { ...action.results.channel },
//             }
//         case 'RESULT_RELATED_UPDATE':
//             return {
//                 ...state,
//                 relatedTagsQuery: action.relatedTagsQuery
//             }
//         case RESULT_CHANNEL_FILTER_UPDATE:
//             return {
//                 ...state,
//                 channel: { ...action.results.channel },
//                 dataTypes: action.results.dataTypes ? [...action.results.dataTypes] :[],
//                 relatedDocs: action.results.relatedDocs   ? [...action.results.relatedDocs] : [],
//             }
//         default:
//             return state
//     }
// }

// export default input